import React, { useCallback } from 'react';
import CheckboxField from '@components/core/CheckboxField';
import SegmentedControl from '@components/core/SegmentedControl';
import Button from '@components/legacy/core/Button';
import Select2 from '@components/legacy/core/Select2';
import { SCHEDULE_TIME_OPTIONS, SCHEDULE_CONDITION_QUESTIONS } from '../../config';
import './ScheduledAutomationSidebar.less';

const SCHEDULED_FREQUENCY_SELECT_ID = 'automation-modal-select-scheduled-frequency';
const SCHEDULED_TIME_SELECT_ID = 'automation-modal-select-scheduled-time';
const SCHEDULED_QUESTION_SELECT_ID = 'automation-modal-select-scheduled-question';

const TIME_OPTIONS = SCHEDULE_TIME_OPTIONS.map((o) => ({ id: o.id, text: o.label }));
const QUESTION_OPTIONS = SCHEDULE_CONDITION_QUESTIONS.map((q) => ({ id: q.id, text: q.label }));

const emptyAnswer = () => ({ checkedIds: [], matchMode: 'any' });

/**
 * Scheduled trigger: time row, conditions panel, optional question card.
 * `value` / `onChange` are controlled by the parent modal.
 */
const ScheduledAutomationSidebar = ({
    value,
    onChange,
    t,
    select2ParentSelector = '.add-automation-modal',
}) => {
    const { frequency, time, combine, selectedQuestionId, answers } = value;

    const patch = useCallback((partial) => onChange({ ...value, ...partial }), [value, onChange]);

    const active = SCHEDULE_CONDITION_QUESTIONS.find((q) => q.id === selectedQuestionId);
    const answer = selectedQuestionId ? answers[selectedQuestionId] || emptyAnswer() : emptyAnswer();

    return null
    // return (
        
        // <div className="auto-sched">
        //     <div className="auto-sched-time-row">
        //         <div className="auto-sched-time-cell">
        //             <Select2
        //                 id={SCHEDULED_FREQUENCY_SELECT_ID}
        //                 className="auto-sched-select"
        //                 value={frequency}
        //                 onChange={(v) => patch({ frequency: v || frequencies?.[0]?.id })}
        //                 options={frequencies?.map(({ id, name }) => ({ id, text: name }))}
        //                 allowClear={false}
        //                 allowEmpty={false}
        //                 hideSearch
        //                 parentSelector={select2ParentSelector}
        //             />
        //         </div>
        //         <div className="auto-sched-time-cell">
        //             <Select2
        //                 id={SCHEDULED_TIME_SELECT_ID}
        //                 className="auto-sched-select"
        //                 value={time}
        //                 onChange={(v) => patch({ time: v || SCHEDULE_TIME_OPTIONS[0].id })}
        //                 options={TIME_OPTIONS}
        //                 allowClear={false}
        //                 allowEmpty={false}
        //                 hideSearch
        //                 parentSelector={select2ParentSelector}
        //             />
        //         </div>
        //     </div>

        //     <div className="auto-sched-section-title">{t('With these conditions')}</div>

        //     <div className="auto-sched-panel">
        //         <SegmentedControl
        //             className="auto-sched-logic"
        //             ariaLabel={t('Combine conditions')}
        //             value={combine}
        //             onChange={(next) => patch({ combine: next })}
        //             options={[
        //                 { id: 'and', label: t('AND') },
        //                 { id: 'or', label: t('OR') },
        //             ]}
        //         />

        //         <Button type="link" className="auto-sched-criteria-add" icon="icon-svg-plus" onClick={() => {}}>
        //             {t('Add a criteria')}
        //         </Button>

        //         <div className="auto-sched-question-label">{t('Select application question')}</div>

        //         <div className="auto-sched-question-field">
        //             <Select2
        //                 id={SCHEDULED_QUESTION_SELECT_ID}
        //                 className="auto-sched-select"
        //                 value={selectedQuestionId}
        //                 onChange={(v) => {
        //                     const qid = v || '';
        //                     const nextAnswers = { ...answers };
        //                     if (qid && !nextAnswers[qid]) nextAnswers[qid] = emptyAnswer();
        //                     patch({ selectedQuestionId: qid, answers: nextAnswers });
        //                 }}
        //                 options={QUESTION_OPTIONS}
        //                 placeholder={t('Select question')}
        //                 allowClear={false}
        //                 allowEmpty
        //                 hideSearch
        //                 parentSelector={select2ParentSelector}
        //             />
        //         </div>

        //         {active ? (
        //             <div className="auto-sched-condition-card">
        //                 <div className="auto-sched-condition-card-head">
        //                     <span className="auto-sched-condition-card-title">{active.label}</span>
        //                     <Button
        //                         type="link"
        //                         onlyIcon
        //                         icon="icon-svg-x-close"
        //                         className="auto-sched-condition-card-close"
        //                         aria-label={t('Close')}
        //                         onClick={() => patch({ selectedQuestionId: '' })}
        //                     />
        //                 </div>
        //                 <ul className="auto-sched-answers">
        //                     {active.choices.map((c) => (
        //                         <li key={c.id} className="auto-sched-answer">
        //                             <CheckboxField
        //                                 label={c.label}
        //                                 checkboxId={`sched-q-${active.id}-${c.id}`}
        //                                 isChecked={answer.checkedIds.includes(c.id)}
        //                                 onChange={() => {
        //                                     const prev = answers[selectedQuestionId] || emptyAnswer();
        //                                     const checkedIds = prev.checkedIds.includes(c.id)
        //                                         ? prev.checkedIds.filter((x) => x !== c.id)
        //                                         : [...prev.checkedIds, c.id];
        //                                     patch({
        //                                         answers: {
        //                                             ...answers,
        //                                             [selectedQuestionId]: { ...prev, checkedIds },
        //                                         },
        //                                     });
        //                                 }}
        //                             />
        //                         </li>
        //                     ))}
        //                 </ul>
        //                 <SegmentedControl
        //                     className="auto-sched-match"
        //                     compact
        //                     ariaLabel={t('Answer match mode')}
        //                     value={answer.matchMode}
        //                     onChange={(mode) => {
        //                         const prev = answers[selectedQuestionId] || emptyAnswer();
        //                         patch({
        //                             answers: {
        //                                 ...answers,
        //                                 [selectedQuestionId]: { ...prev, matchMode: mode },
        //                             },
        //                         });
        //                     }}
        //                     options={[
        //                         { id: 'any', label: t('ANY') },
        //                         { id: 'all', label: t('ALL') },
        //                     ]}
        //                 />
        //             </div>
        //         ) : null}

        //         <Button type="default" className="auto-sched-group-add" icon="icon-svg-plus" onClick={() => {}}>
        //             {t('Add a new group')}
        //         </Button>
        //     </div>
        // </div>
    // );
};

export default ScheduledAutomationSidebar;
